import RecoverStep from "../recover_step";

const TEMPLATE = 'export-change-format';

export default class ExportChangeFormat extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    transitionTryAgain(data, el, fr) {
        data.recovery.virtualization.format = data.tmp.format;
        if(data.tmp.fromFailover) {
            fr.goTo('exportVmFailover');
        } else {
            fr.goTo('exportVm');
        }
    }

}
